import { connect } from 'react-redux';

import { downloadSmsesCSV } from '../../../../../state/modules/smses/actions';
import SmsesCSVButton from '../components/SmsesCSVButton';

const mapStateToProps = (state) => {
  return {
    isDownloading: state.smses.get('isCSVDownloading'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    download: (order, filter, cb) => {
      dispatch(downloadSmsesCSV(order, filter, cb));
    },
  };
};

const SmsesCSVButtonContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SmsesCSVButton);

export default SmsesCSVButtonContainer;
